import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { AddIcon, Button, Card, FlexGap, Paragraph, SettingsSection } from '@treams/treams-ui';

import GoalTemplateRow from './GoalTemplateRow';

export default function GoalTemplates(props: { jobTitle: graphql.JobTitle }) {
	const { t } = useTranslation();
	const { localize } = useLocalize();
	const history = useHistory();

	const addTemplate = () => history.push('/settings/goals/templates');

	const goalTemplates = _.sortBy(
		props.jobTitle.goalTemplates.edges.map(({ node }) => node),
		(template) => localize(template.title).text,
	);

	return (
		<SettingsSection title={t('settings.jobGoalTemplates.title')}>
			{goalTemplates.length === 0 ? (
				<>
					<Paragraph mb={0}>{t('settings.jobGoalTemplates.empty.title')}</Paragraph>
					<Button
						type="secondary"
						icon={<AddIcon />}
						title={t('settings.jobGoalTemplates.addButton.title')}
						onClick={addTemplate}
					/>
				</>
			) : (
				<>
					<FlexGap justifyContent="flex-end" width="100%">
						<Button
							type="secondary"
							icon={<AddIcon />}
							title={t('settings.jobGoalTemplates.addButton.title')}
							onClick={addTemplate}
						/>
					</FlexGap>
					<Card p={0}>
						{goalTemplates.map((template) => (
							<GoalTemplateRow
								key={template.id}
								goalTemplate={template as graphql.GoalTemplate}
								jobTitle={props.jobTitle}
							/>
						))}
					</Card>
				</>
			)}
		</SettingsSection>
	);
}
